import { Injectable } from '@angular/core';
import { TopicSearchService } from '@app/origami-api/services/topic-search.service';
import { Observable, of } from 'rxjs';
import { NumberHash } from '@app/shared/utils/utils-types';
import { map } from 'rxjs/operators';
import { Topic } from '@app/origami-api/utils/topic-utils';

@Injectable()
export class TopicTitlesService {
  private hash: NumberHash<NumberHash<NumberHash<string>>> = {};

  constructor(private topicSearchService: TopicSearchService) {}

  getTopics(
    roomId: number,
    topicTypeIds: (
      | number
      | { topicTypeId: number; topicIdGetter?: (topic: Topic) => number; topicTitleGetter?: (topic: Topic) => string }
    )[],
    force?: boolean,
  ): Observable<NumberHash<NumberHash<string>>> {
    const topicTypes = topicTypeIds.map((item) => ({
      topicTypeId: typeof item === 'number' ? item : item.topicTypeId,
      topicIdGetter: (topic: Topic) =>
        typeof item === 'number' || !item.topicIdGetter ? topic.TopicId : item.topicIdGetter(topic),
      topicTitleGetter: (topic: Topic) =>
        typeof item === 'number' || !item.topicTitleGetter ? topic.TopicName : item.topicTitleGetter(topic),
    }));

    if (!force && this.hash[roomId] && topicTypes.every((item) => !!this.hash[roomId][item.topicTypeId])) {
      return of(this.hash[roomId]);
    }

    return this.topicSearchService
      .searchTopics({
        topicTypeId: topicTypes[0].topicTypeId,
        siteId: roomId,
        additionalTopicTypeIds: topicTypes.slice(1).map((item) => item.topicTypeId),
      })
      .pipe(
        map((res) => {
          this.hash[roomId] = this.hash[roomId] || {};

          if (res && res.Result && res.Result.TopicList) {
            const topicTypesHash = topicTypes.reduce((r, item) => {
              r[item.topicTypeId] = item;
              return r;
            }, {});

            res.Result.TopicList.forEach((topic) => {
              const item = topicTypesHash[topic.TopicTypeId];

              this.hash[roomId][topic.TopicTypeId] = this.hash[roomId][topic.TopicTypeId] || {};
              this.hash[roomId][topic.TopicTypeId][item.topicIdGetter(topic)] = item.topicTitleGetter(topic);
            });
          }

          return this.hash[roomId];
        }),
      );
  }
}
